import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e552fc44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-bookings" }
const _hoisted_2 = { class: "search-bookings__submit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseDateInput = _resolveComponent("BaseDateInput")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "search-bookings__form",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
    }, [
      _createVNode(_component_BaseInput, {
        name: "bookingNumber",
        type: "tel",
        hasError: _ctx.v$.bookingNumber.$error,
        errors: _ctx.v$.bookingNumber.$errors,
        valid: !_ctx.v$.bookingNumber.$invalid,
        modelValue: _ctx.v$.bookingNumber.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.bookingNumber.$model) = $event)),
        label: _ctx.$t('account.myBookings.search.bookingNumber'),
        class: "search-bookings__input"
      }, null, 8, ["hasError", "errors", "valid", "modelValue", "label"]),
      _createVNode(_component_BaseInput, {
        name: "customerEmail",
        type: "email",
        hasError: _ctx.v$.customerEmail.$error,
        errors: _ctx.v$.customerEmail.$errors,
        valid: !_ctx.v$.customerEmail.$invalid,
        modelValue: _ctx.v$.customerEmail.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.customerEmail.$model) = $event)),
        label: _ctx.$t('account.myBookings.search.customerEmail'),
        class: "search-bookings__input"
      }, null, 8, ["hasError", "errors", "valid", "modelValue", "label"]),
      _createVNode(_component_BaseDateInput, {
        name: "date",
        hasError: _ctx.v$.date.$error,
        errors: _ctx.v$.date.$errors,
        valid: !_ctx.v$.date.$invalid,
        modelValue: _ctx.v$.date.$model,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.date.$model) = $event)),
        label: "DD/MM/YYYY",
        class: "search-bookings__input"
      }, null, 8, ["hasError", "errors", "valid", "modelValue"]),
      _createVNode(_component_BaseInput, {
        name: "customerName",
        type: "text",
        hasError: _ctx.v$.customerName.$error,
        errors: _ctx.v$.customerName.$errors,
        valid: !_ctx.v$.customerName.$invalid,
        modelValue: _ctx.v$.customerName.$model,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.customerName.$model) = $event)),
        label: _ctx.$t('account.myBookings.search.customerName'),
        class: "search-bookings__input"
      }, null, 8, ["hasError", "errors", "valid", "modelValue", "label"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BaseButton, {
          loading: _ctx.loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('account.myBookings.search.button')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32)
  ]))
}